import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { RouteErrorDisplay } from '@/components/RouteErrorDisplay'
import { requireAnyPermission } from '@/lib/auth/route-guards'
import type { RouterAuthContext } from '@/lib/auth/router-context'
import { z } from 'zod'

const reportingSearchSchema = z.object({
  tab: z.enum(['billing', 'attendance', 'classes', 'teachers']).optional(),
  range: z.string().optional().default('30d'),
})

export const Route = createFileRoute('/app/reporting')({
  validateSearch: reportingSearchSchema,

  // Permission guard: requires any reporting permission
  beforeLoad: async ({ context, location }) => {
    await requireAnyPermission(
      context as RouterAuthContext,
      [
        'reporting:view-attendance',
        'reporting:view-revenue',
        'reporting:view-member-stats',
      ],
      { currentPath: location.pathname }
    )
  },

  component: lazyRouteComponent(() => import('./-reporting')),
  errorComponent: ({ error }) => (
    <QueryErrorResetBoundary>
      {({ reset }) => <RouteErrorDisplay error={error} reset={reset} />}
    </QueryErrorResetBoundary>
  ),
})
